import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const LogisticsManagement = lazy(() => import('../LogisticsManagement'));

const LogisticsManagementRoutes: RouteObject[] = [
  {
    path: 'logistics-management',
    element: <LogisticsManagement />,
  },
];

export default LogisticsManagementRoutes;
